import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { PageHeader } from '../components/Shared';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3002/api';

function ModalUtilisateur({ utilisateur, roles, onSave, onClose }) {
  const [form, setForm] = useState(
    utilisateur
      ? { ...utilisateur, password: '' }
      : { login: '', password: '', nom: '', prenom: '', email: '', role: roles[0]?.nom || 'visiteur', actif: true }
  );
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const { token } = useAuth();

  const roleColors = { admin: '#f59e0b', utilisateur: '#3b82f6' };

  async function handleSave() {
    if (!form.login || (!utilisateur && !form.password) || !form.role) {
      setError('Login, mot de passe et rôle sont requis');
      return;
    }
    setSaving(true);
    setError('');
    try {
      const method = utilisateur ? 'PUT' : 'POST';
      const url = utilisateur ? `${API_BASE}/utilisateurs/${utilisateur.id}` : `${API_BASE}/utilisateurs`;
      const body = {
        login: form.login,
        nom: form.nom,
        prenom: form.prenom,
        email: form.email,
        role: form.role,
        actif: form.actif,
        vues_autorisees: form.vues_autorisees,
        formateur_id: form.formateur_id || null,
      };
      if (form.password) body.password = form.password;
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      onSave(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  }

  const field = (label, key, type = 'text', disabled = false, extra = {}) => (
    <div style={{ marginBottom: '0.8rem' }}>
      <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.3rem' }}>
        {label}
      </label>
      <input type={type} value={form[key] || ''} disabled={disabled}
        onChange={e => setForm({ ...form, [key]: e.target.value })}
        style={{ width: '100%', padding: '0.5rem 0.7rem', borderRadius: '6px', border: '1px solid var(--border)', background: disabled ? 'var(--bg-hover)' : 'var(--bg-elevated)', color: 'var(--text-primary)', fontSize: '0.9rem', boxSizing: 'border-box' }}
        {...extra}
      />
    </div>
  );

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '12px', padding: '2rem', width: '460px', maxWidth: '95vw', maxHeight: '90vh', overflowY: 'auto' }}>
        <h3 style={{ marginBottom: '1.5rem', color: 'var(--text-primary)' }}>
          {utilisateur ? 'Modifier l\'utilisateur' : 'Nouvel utilisateur'}
        </h3>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 0.8rem' }}>
          {field('Prénom', 'prenom')}
          {field('Nom', 'nom')}
        </div>
        {field('Login *', 'login', 'text', false)}
        {field(utilisateur ? 'Nouveau mot de passe (vide = inchangé)' : 'Mot de passe *', 'password', 'password', false, { autoComplete: 'new-password' })}
        {field('Email', 'email', 'email')}

        <div style={{ marginBottom: '1rem' }}>
          <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.5rem' }}>
            Rôle *
          </label>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
            {roles.map(r => (
              <label key={r.nom} style={{ display: 'flex', alignItems: 'center', gap: '0.7rem', padding: '0.6rem 0.8rem', borderRadius: '8px', border: `2px solid ${form.role === r.nom ? (roleColors[r.nom] || 'var(--accent)') : 'var(--border)'}`, cursor: 'pointer', background: form.role === r.nom ? `${roleColors[r.nom] || 'var(--accent)'}11` : 'transparent' }}>
                <input type="radio" name="role" value={r.nom} checked={form.role === r.nom}
                  onChange={() => setForm({ ...form, role: r.nom })} />
                <div>
                  <div style={{ fontWeight: 600, fontSize: '0.9rem', color: roleColors[r.nom] || 'var(--text-primary)' }}>
                    {r.nom.charAt(0).toUpperCase() + r.nom.slice(1)}
                  </div>
                  {r.description && <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>{r.description}</div>}
                </div>
              </label>
            ))}
          </div>
        </div>

        {utilisateur && (
          <div style={{ marginBottom: '0.8rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <input type="checkbox" id="actif" checked={form.actif}
              onChange={e => setForm({ ...form, actif: e.target.checked })} />
            <label htmlFor="actif" style={{ fontSize: '0.9rem', color: 'var(--text-secondary)' }}>Compte actif</label>
          </div>
        )}

        {error && (
          <div style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: '6px', padding: '0.5rem 0.8rem', marginBottom: '1rem', color: '#f87171', fontSize: '0.85rem' }}>
            {error}
          </div>
        )}

        <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end', marginTop: '1.5rem' }}>
          <button className="btn-secondary" onClick={onClose} disabled={saving}>Annuler</button>
          <button className="btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? 'Enregistrement...' : 'Enregistrer'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function Utilisateurs() {
  const { token } = useAuth();
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);

  useEffect(() => {
    Promise.all([
      fetch(`${API_BASE}/utilisateurs`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()),
      fetch(`${API_BASE}/roles`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()),
    ]).then(([u, r]) => {
      setUsers(u.data || []);
      setRoles(r.data || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [token]);

  async function handleDesactiver(id) {
    if (!window.confirm('Désactiver cet utilisateur ?')) return;
    await fetch(`${API_BASE}/utilisateurs/${id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
    setUsers(users.map(u => u.id === id ? { ...u, actif: false } : u));
  }

  async function handleReactiver(id) {
    await fetch(`${API_BASE}/utilisateurs/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ actif: true }),
    });
    setUsers(users.map(u => u.id === id ? { ...u, actif: true } : u));
  }

  async function handleSupprimer(id, login) {
    if (!window.confirm(`Supprimer définitivement l'utilisateur "${login}" ?\nCette action est irréversible.`)) return;
    const res = await fetch(`${API_BASE}/utilisateurs/${id}/supprimer`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
    if (res.ok) setUsers(users.filter(u => u.id !== id));
    else { const d = await res.json(); alert(d.error); }
  }

  function handleSaved(saved) {
    setUsers(prev => {
      const exists = prev.find(u => u.id === saved.id);
      return exists ? prev.map(u => u.id === saved.id ? saved : u) : [...prev, saved];
    });
    setModal(null);
  }

  const roleColor = nom => ({ admin: '#f59e0b', utilisateur: '#3b82f6' }[nom] || 'var(--accent)');

  return (
    <div className="page">
      <PageHeader
        title="Utilisateurs"
        subtitle="Gestion des accès à l'application"
        actions={<button className="btn-primary" onClick={() => setModal('new')}>+ Nouvel utilisateur</button>}
      />

      {loading ? <p>Chargement...</p> : (
        <div className="card">
          <table className="data-table" style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>Login</th><th>Nom</th><th>Email</th><th>Rôle</th><th>Statut</th><th>Dernière connexion</th><th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map(u => (
                <tr key={u.id} style={{ opacity: u.actif ? 1 : 0.4 }}>
                  <td><strong>{u.login}</strong></td>
                  <td>{u.prenom} {u.nom}</td>
                  <td style={{ color: 'var(--text-secondary)', fontSize: '0.85rem' }}>{u.email}</td>
                  <td>
                    <span style={{ color: roleColor(u.role), fontWeight: 600, fontSize: '0.85rem' }}>
                      {u.role?.charAt(0).toUpperCase() + u.role?.slice(1)}
                    </span>
                  </td>
                  <td>
                    <span style={{ padding: '0.2rem 0.6rem', borderRadius: '20px', fontSize: '0.75rem', fontWeight: 600, background: u.actif ? 'rgba(16,185,129,0.1)' : 'rgba(239,68,68,0.1)', color: u.actif ? '#10b981' : '#ef4444' }}>
                      {u.actif ? 'Actif' : 'Inactif'}
                    </span>
                  </td>
                  <td style={{ color: 'var(--text-tertiary)', fontSize: '0.8rem' }}>
                    {u.last_login ? new Date(u.last_login).toLocaleString('fr-FR') : '—'}
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: '0.4rem', flexWrap: 'wrap' }}>
                      <button className="btn-secondary" style={{ fontSize: '0.75rem', padding: '0.2rem 0.6rem' }}
                        onClick={() => setModal({ utilisateur: u })}>✏️ Modifier</button>
                      {u.actif ? (
                        <button className="btn-secondary" style={{ fontSize: '0.75rem', padding: '0.2rem 0.6rem', color: '#f59e0b', borderColor: '#f59e0b' }}
                          onClick={() => handleDesactiver(u.id)}>🚫 Désactiver</button>
                      ) : (
                        <button className="btn-secondary" style={{ fontSize: '0.75rem', padding: '0.2rem 0.6rem', color: '#10b981', borderColor: '#10b981' }}
                          onClick={() => handleReactiver(u.id)}>✅ Réactiver</button>
                      )}
                      <button className="btn-secondary" style={{ fontSize: '0.75rem', padding: '0.2rem 0.6rem', color: '#ef4444', borderColor: '#ef4444' }}
                        onClick={() => handleSupprimer(u.id, u.login)}>🗑 Supprimer</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {modal && (
        <ModalUtilisateur
          utilisateur={modal === 'new' ? null : modal.utilisateur}
          roles={roles}
          onSave={handleSaved}
          onClose={() => setModal(null)}
        />
      )}
    </div>
  );
}
